import gql from 'graphql-tag';

export const UPDATE_DEPARTMENT = gql`
  mutation UpdateDepartment($input: UpdateDepartmentInput!) {
    bpf {
      result: updateDepartment(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
